import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import config from '../services/firebaseConfig'
import User from '../models/User'
import userRepository from '../repositories/UserRepository'
import eventTracker from './eventTracker'

if (!firebase.apps.length) {
  firebase.initializeApp(config)
}

const authService = {
  authenticateWith (authProvider) {
    return new Promise((resolve, reject) => {
      let provider = 'google'
      switch (authProvider) {
        case 'google':
          provider = new firebase.auth.GoogleAuthProvider()
          provider.addScope('profile')
          break

        case 'facebook':
          provider = new firebase.auth.FacebookAuthProvider()
          provider.addScope('email,public_profile')
          break

        default:
          break
      }
      firebase.auth().useDeviceLanguage()
      firebase.auth().signInWithPopup(provider).then(userObj => {
        userRepository.saveUser(new User(userObj.user.uid, userObj.user.displayName, userObj.user.email, userObj.user.photoURL)).then(() => {
          eventTracker.trackSuccessfullSignIn()
          resolve(true)
        }).catch(error => {
          reject(error)
        })
      }).catch((error) => {
        reject(error)
      })
    })
  },

  getCurrentUser () {
    const user = firebase.auth().currentUser
    if (user) {
      return new User(user.uid, user.displayName, user.email, user.photoURL)
    } else {
      return null
    }
  }
}

export default authService



// WEBPACK FOOTER //
// ./src/services/authenticationService.js